import { Button, Input, InputNumber } from 'antd';
import React, { useState } from 'react';
import { StandardizedAddressFiltersInput } from '../graphql/queries/getStandardizedAddressListing';

export type FilterOptions = {
  id: string;
  line1: string;
  latitude: number | null;
  longitude: number | null;
  city: string;
  state: string;
  zipcode: string;
};

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  id: '',
  line1: '',
  latitude: null,
  longitude: null,
  city: '',
  state: '',
  zipcode: '',
};

interface FilterAreaProps {
  filters: FilterOptions;
  handleFilter: (options: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, handleFilter }) => {
  const [filterOptions, setFilterOptions] = useState<FilterOptions>(filters || DEFAULT_FILTER_OPTIONS);

  const handleReset = () => {
    const resetFilters = DEFAULT_FILTER_OPTIONS;
    setFilterOptions(resetFilters);
    handleFilter(resetFilters);
  };

  const handleSearch = () => {
    handleFilter(filterOptions);
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="flex items-center flex-1 min-w-0">
          <label className="text-sm font-medium mr-2 whitespace-nowrap flex-shrink-0">ID:</label>
          <Input
            placeholder="请输入ID"
            value={filterOptions.id}
            onChange={(e) => setFilterOptions({ ...filterOptions, id: e.target.value })}
            allowClear
            className="flex-1 min-w-0"
          />
        </div>

        <div className="flex items-center flex-1 min-w-0">
          <label className="text-sm font-medium mr-2 whitespace-nowrap flex-shrink-0">Line 1:</label>
          <Input
            placeholder="请输入Line 1"
            value={filterOptions.line1}
            onChange={(e) => setFilterOptions({ ...filterOptions, line1: e.target.value })}
            allowClear
            className="flex-1 min-w-0"
          />
        </div>

        <div className="flex items-center flex-1 min-w-0">
          <label className="text-sm font-medium mr-2 whitespace-nowrap flex-shrink-0">坐标:</label>
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <InputNumber
              placeholder="纬度"
              value={filterOptions.latitude}
              onChange={(value) => setFilterOptions({ ...filterOptions, latitude: value })}
              precision={7}
              min={-90}
              max={90}
              style={{ width: '100%' }}
              className="flex-1 min-w-0"
            />
            <InputNumber
                placeholder="经度"
                value={filterOptions.longitude}
                onChange={(value) => setFilterOptions({ ...filterOptions, longitude: value })}
                precision={7}
                min={-180}
                max={180}
                style={{ width: '100%' }}
                className="flex-1 min-w-0"
            />
          </div>
        </div>

        <div className="flex items-center flex-1 min-w-0">
          <label className="text-sm font-medium mr-2 whitespace-nowrap flex-shrink-0">城市:</label>
          <Input
            placeholder="请输入城市"
            value={filterOptions.city}
            onChange={(e) => setFilterOptions({ ...filterOptions, city: e.target.value })}
            allowClear
            className="flex-1 min-w-0"
          />
        </div>

        <div className="flex items-center flex-1 min-w-0">
          <label className="text-sm font-medium mr-2 whitespace-nowrap flex-shrink-0">州:</label>
          <Input
            placeholder="请输入州"
            value={filterOptions.state}
            onChange={(e) => setFilterOptions({ ...filterOptions, state: e.target.value })}
            allowClear
            className="flex-1 min-w-0"
          />
        </div>

        <div className="flex items-center flex-1 min-w-0">
          <label className="text-sm font-medium mr-2 whitespace-nowrap flex-shrink-0">邮编:</label>
          <Input
            placeholder="请输入邮编"
            value={filterOptions.zipcode}
            onChange={(e) => setFilterOptions({ ...filterOptions, zipcode: e.target.value })}
            allowClear
            className="flex-1 min-w-0"
          />
        </div>
      </div>

      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={handleReset}>重置</Button>
        <Button type="primary" onClick={handleSearch}>
          查询
        </Button>
      </div>
    </div>
  );
};

export const convertToGraphQLFilters = (options: FilterOptions): StandardizedAddressFiltersInput => {
  const graphQLFilters: StandardizedAddressFiltersInput = {};

  if (options.id && options.id.trim()) {
    const idNum = parseInt(options.id.trim(), 10);
    if (!isNaN(idNum)) {
      graphQLFilters.id = idNum;
    }
  }

  if (options.line1 && options.line1.trim()) {
    graphQLFilters.line1 = options.line1.trim();
  }

  // 只有当纬度和经度都不为空时才设置 coordinates
  if (options.latitude != null && options.longitude != null) {
    graphQLFilters.coordinates = {
      latitude: options.latitude,
      longitude: options.longitude,
    };
  }

  if (options.city && options.city.trim()) {
    graphQLFilters.city = options.city.trim();
  }

  if (options.state && options.state.trim()) {
    graphQLFilters.state = options.state.trim();
  }

  if (options.zipcode && options.zipcode.trim()) {
    graphQLFilters.zipcode = options.zipcode.trim();
  }

  return graphQLFilters;
};

export default FilterArea;

